<template>
    <div class="component morph-wrap" ref="wrapper">
        <svg class="morph" viewBox="0 0 1400 770" ref="svg">
            <path
                ref="shapeEl"
                d="M 262.9,252.2 C 210.1,338.2 212.6,487.6 288.8,553.9 372.2,626.5 511.2,517.8 620.3,536.3 750.6,558.4 860.3,723 987.3,686.5 1089,657.3 1168,534.7 1173,429.2 1178,313.7 1096,189.1 995.1,130.7 852.1,47.07 658.8,78.95 498.1,119.2 410.7,141.1 322.6,154.8 262.9,252.2 Z"
            />
        </svg>
    </div>
</template>

<script>
    import anime from 'animejs/lib/anime.es.js';
    import shapes from './background-shapes.js';

    export default {
        name: 'BackgroundShape',
        mounted() {
            this.initShapeEl();
        },
        methods: {
            initShapeEl() {
                anime.remove(this.$refs.svg);
                anime({
                    targets: this.$refs.svg,
                    duration: 1,
                    easing: 'linear',
                    scaleX: shapes['opener'].scaleX,
                    scaleY: shapes['opener'].scaleY,
                    translateX: shapes['opener'].tx + '%',
                    translateY: shapes['opener'].ty + '%',
                    rotate: shapes['opener'].rotate + 'deg',
                });
                this.triggerOpenerLoop();
            },
            initLoop(pos) {
                anime.remove(this.$refs.shapeEl);
                anime({
                    targets: this.$refs.shapeEl,
                    easing: 'linear',
                    d: [
                        { value: shapes[pos].pathAlt, duration: 3500 },
                        { value: shapes[pos].path, duration: 3500 },
                    ],
                    loop: true,
                    fill: {
                        value: shapes[pos].fill.color,
                        duration: shapes[pos].fill.duration,
                        easing: shapes[pos].fill.easing,
                    },
                    direction: 'alternate',
                });
            },
            triggerOpenerLoop() {
                anime.remove(this.$refs.shapeEl);
                const timeline = anime.timeline({
                    loop: true,
                    autoplay: true,
                });

                timeline
                    .add({
                        targets: this.$refs.shapeEl,
                        easing: 'easeInOutSine',
                        d: [
                            { value: shapes['opener'].pathAlt, duration: 4000 },
                            { value: shapes['opener'].path, duration: 4000 },
                        ],
                        loop: true,
                        fill: {
                            value: shapes['opener'].fill.color,
                            duration: shapes['opener'].fill.duration,
                            easing: shapes['opener'].fill.easing,
                        },
                        direction: 'alternate',
                    })
                    .add({
                        targets: this.$refs.shapeEl,
                        easing: 'easeInOutSine',
                        d: [
                            { value: shapes['third'].pathAlt, duration: 4000 },
                            { value: shapes['third'].path, duration: 4000 },
                        ],
                        loop: true,
                        fill: {
                            value: shapes['third'].fill.color,
                            duration: shapes['third'].fill.duration,
                            easing: shapes['third'].fill.easing,
                        },
                        direction: 'alternate',
                    })
                    .add({
                        targets: this.$refs.shapeEl,
                        easing: 'easeInOutSine',
                        d: [
                            { value: shapes['second'].pathAlt, duration: 4000 },
                            { value: shapes['second'].path, duration: 4000 },
                        ],
                        loop: true,
                        fill: {
                            value: shapes['second'].fill.color,
                            duration: shapes['second'].fill.duration,
                            easing: shapes['second'].fill.easing,
                        },
                        direction: 'alternate',
                    })
                    .add({
                        targets: this.$refs.shapeEl,
                        easing: 'easeInOutSine',
                        d: [
                            { value: shapes['opener'].pathAlt, duration: 4000 },
                            { value: shapes['opener'].path, duration: 4000 },
                        ],
                        loop: true,
                        fill: {
                            value: shapes['opener'].fill.color,
                            duration: shapes['opener'].fill.duration,
                            easing: shapes['opener'].fill.easing,
                        },
                        direction: 'alternate',
                    });
                return;
            },
            triggerShapeChange(data) {
                const index = data;

                // do this with bindings later on!!

                this.$refs.wrapper.classList.forEach(className => {
                    if (className.startsWith('bg-')) {
                        this.$refs.wrapper.classList.remove(className);
                    }
                });

                if (shapes[index].backgroundColor) {
                    this.$refs.wrapper.classList.add(`bg-${shapes[index].backgroundColor}`);
                } else {
                    this.$refs.wrapper.classList.add('bg-transparent');
                }

                anime.remove(this.$refs.shapeEl);
                anime({
                    targets: this.$refs.shapeEl,
                    duration: shapes[index].animation.path.duration,
                    easing: shapes[index].animation.path.easing,
                    elasticity: shapes[index].animation.path.elasticity || 0,
                    d: shapes[index].path,
                    fill: {
                        value: shapes[index].fill.color,
                        duration: shapes[index].fill.duration,
                        easing: shapes[index].fill.easing,
                    },
                    complete: () => {
                        if (data === 'opener') {
                            this.triggerOpenerLoop();
                        } else {
                            this.initLoop(index);
                        }
                    },
                });

                anime.remove(this.$refs.svg);
                anime({
                    targets: this.$refs.svg,
                    opacity: 1,
                    duration: shapes[index].animation.svg.duration,
                    easing: shapes[index].animation.svg.easing,
                    elasticity: shapes[index].animation.svg.elasticity || 0,
                    scaleX: shapes[index].scaleX,
                    scaleY: shapes[index].scaleY,
                    translateX: shapes[index].tx + '%',
                    translateY: shapes[index].ty + '%',
                    rotate: shapes[index].rotate + 'deg',
                });
            },
        },
        computed: {
            backgroundShape() {
                return this.$store.getters.backgroundShape;
            },
        },
        watch: {
            backgroundShape: function(val) {
                this.triggerShapeChange(val);
            },
        },
    };
</script>

<style scoped lang="scss">
    .morph-wrap {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        transition: background-color 0.5s;
        opacity: 0;
        animation: anim-fade-in 1s 0.3s forwards;

        @keyframes anim-fade-in {
            from {
                opacity: 0;
            }

            to {
                opacity: 1;
            }
        }
    }

    .morph {
        position: relative;
        height: 100%;
        fill: color('white-lilac');
        flex: none;

        @media (max-width: breakpoint('large')) {
            transition: height 0.5s;

            body.fp-viewing-user-and-brand & {
                height: 110%;
            }

            body.fp-viewing-experience-principles & {
                height: 130%;
            }
        }
    }
</style>
